<template>
    <el-dialog
            :visible.sync="visible"
            custom-class="mak-camera-dialog"
            fullscreen>

        <div v-show="deviceId" class="mak-camera-container">
            <web-cam
                    ref="camera"
                    class="mak-camera"
                    :device-id="deviceId"
                    @started="started"
                    @stopped="stopped"
                    @error="error"
                    @cameras="cameras"/>

            <i @click="visible = false" class="el-icon-close"></i>

            <div v-if="deviceId" class="mak-camera-bottom">
                <div></div>

                <div class="mak-capture-btn" @click="capture">
                    <i class="el-icon-camera-solid"></i>
                </div>

                <div>
                    <i v-if="devices.length > 2"
                       class="mak-change-btn el-icon-refresh"
                       @click="change"/>
                </div>
            </div>
        </div>

        <div class="mak-images-container">
            <div v-for="(img, i) in images"
                 :key="`image-${i}`"
                 style="margin-right: 20px">
                <img :src="img.base64" style="width: 240px; height: 180px">
                <el-row type="flex" justify="space-between">
                    <div>{{img.date.toLocaleString()}}</div>
                    <el-button
                            type="danger"
                            size="small"
                            icon="el-icon-delete"
                            @click="images.splice(i, 1)"/>
                </el-row>
            </div>
        </div>

        <el-button
                v-if="images.length"
                :disabled="!images.length"
                @click="$emit('use', this.images)">
            Fotoğrafları Kaydet
        </el-button>
    </el-dialog>
</template>

<script>
    import {WebCam} from 'vue-web-cam';

    export default {
        name: 'mak-camera',
        model: {
            props: 'value',
            event: 'change',
        },
        props: {
            value: {type: Boolean, required: true},
            makinaId: {type: [Number, String], required: true},
        },
        components: {WebCam},
        data() {
            return {
                visible: false,
                devices: [],
                deviceIndex: 0,
                images: [],
                showActions: false,
            };
        },
        computed: {
            selectedDevice() {
                if (!this.devices.length) {
                    return null;
                }
                return this.devices[this.deviceIndex];
            },
            deviceId() {
                return this.selectedDevice && this.selectedDevice.deviceId;
            },
        },
        methods: {
            started(e) {
                console.warn('started', e);
                this.showActions = true;
            },
            stopped(e) {
                console.warn('stopped', e)
                this.showActions = false;
            },
            error(e) {
                console.warn('error', e)
            },
            cameras(list) {
                this.devices = (list || [])
                    .map(({deviceId, groupId, kind, label}) => ({
                        deviceId,
                        groupId,
                        kind,
                        label,
                    }));
            },
            capture() {
                const {camera} = this.$refs;
                const base64 = camera && camera.capture();
                this.images.push({
                    base64,
                    date: new Date(),
                });
            },
            change() {
                if (this.deviceIndex + 1 < this.devices.length) {
                    this.deviceIndex += 1;
                } else {
                    this.deviceIndex = 0;
                }
            },
        },
        mounted() {
            this.visible = this.value;
        },
        watch: {
            value() {
                this.visible = this.value;
            },
            visible() {
                if (this.value !== this.visible) {
                    this.$emit('change', this.visible);
                }

                // start/stop
                const {camera} = this.$refs;
                if (this.visible && this.selectedDevice) {
                    camera && camera.start();
                } else {
                    camera && camera.stop();
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep .el-dialog__header {
        display: none;
    }

    ::v-deep .el-dialog__body {
        padding: 0;
    }

    .mak-camera-container {
        position: relative;

        i.el-icon-close {
            position: absolute;
            top: 15px;
            right: 15px;
            color: white;
            font-size: 1.3em;
            font-weight: bold;
            padding: 10px;
        }

        .mak-camera-bottom {
            position: absolute;
            bottom: 6px;
            left: 0px;
            width: 100%;
            height: 60px;
            background-color: #00000050;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 1.5em;

            .mak-capture-btn {
                width: 40px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 2px solid #ffffff;
                border-radius: 9999px;

                i {
                    font-size: 1.5em;
                    color: #fff;
                }
            }

            .mak-change-btn {
                font-size: 1.5em;
                color: #fff;
            }
        }
    }

    .mak-camera {
        width: 100%;
        height: 100%;
    }

    .mak-images-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin: 1em;
        padding-bottom: 1em;
        overflow: auto;
    }
</style>
